import { Box } from "@mui/material";
import MechanicsSummary from "./MechanicsSummary.tsx"
import ElectronicsSummary from "./ElectronicsSummary.tsx";
import PageLayout from '../../components/PageLayout.tsx';

const SummaryPage = () => {
  return (
    <PageLayout
      title="Zusammenfassung"
      backText="Zurück zu den Prüfabläufen"
      backTarget="/testprocedure"
      nextText="Weiter zur Anfrage"
      nextTarget="/price"
    >
      <MechanicsSummary />
      <Box mt={2} />
      <ElectronicsSummary /> 
    </PageLayout>
  )
};

export default SummaryPage; 